import React from 'react'
import styled from 'styled-components'

const BUTTON = styled.div`
    background-image: linear-gradient(107deg, var(--main-explosive) -2%, var(--main-dark-explosive) 101%);
    line-height: 17px;
    color: var(--main-text-color);
    font-size:10px;
    padding: 1px 15px;
    @media(min-width: 1024px){
      line-height: 25px;
      font-size: 12px;
    }
`;

export default function SquareButton({ text, onClick }) {
	return (
		<BUTTON onClick={onClick}>{text}</BUTTON>
	)
}
